import { categories } from "@/mocks/categories";

interface HeroProps {
  keyword: string;
  onSearch: (keyword: string) => void;
  onPickCategory: (key: string) => void;
}

const quickWords = ["综艺名场面", "红毯", "片场花絮", "演唱会", "新剧开机"];

export default function Hero({ keyword, onSearch, onPickCategory }: HeroProps) {
  return (
    <section id="top" className="relative flex min-h-[88vh] w-full items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20vibrant%20entertainment%20backdrop%20with%20warm%20coral%2C%20amber%20and%20rose%20light%20streaks%2C%20soft%20bokeh%20and%20stage%20lights%2C%20dynamic%20confetti%20particles%2C%20cinematic%20wide%20composition%2C%20no%20text%2C%20high%20detail%2C%20harmonious%20warm%20tone&width=1600&height=900&seq=hero-chigua-v1&orientation=landscape"
          alt="吃瓜视频在线 首页背景"
          title="吃瓜视频在线 - 娱乐视频聚合平台"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-foreground-950/60" />
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-4 py-24 text-center md:px-6">
        <span className="mb-6 flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-sm text-background-100 backdrop-blur-sm">
          <i className="ri-flashlight-fill text-accent-300" />
          每日更新 · 短视频集锦与完整长视频
        </span>

        <h1 className="font-heading text-4xl leading-tight text-background-50 md:text-6xl md:leading-tight">
          吃瓜视频在线
          <span className="mt-2 block text-2xl text-accent-200 md:text-4xl">
            吃瓜追更，不迷路
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          汇集娱乐八卦、影视花絮、综艺名场面与明星动态，支持按类型与时长筛选。
          短视频集锦、完整长视频、多角度剪辑一应俱全，快速找到你想看的吃瓜内容。
        </p>

        <form
          className="mt-8 flex w-full max-w-xl flex-col items-stretch gap-2 sm:flex-row sm:items-center"
          onSubmit={(e) => {
            e.preventDefault();
            onSearch(keyword.trim());
          }}
        >
          <label className="relative flex-1">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-base text-foreground-500" />
            <input
              type="search"
              value={keyword}
              onChange={(e) => onSearch(e.target.value)}
              placeholder="搜索你想看的吃瓜视频…"
              className="w-full rounded-full bg-background-50 py-3 pl-11 pr-4 text-sm text-foreground-800 placeholder:text-foreground-500 outline-none ring-1 ring-background-300/60 focus:ring-2 focus:ring-primary-400"
            />
          </label>
          <button
            type="submit"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-search-eye-line text-base" />
            立即搜索
          </button>
        </form>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-background-200">大家都在搜：</span>
          {quickWords.map((word) => (
            <button
              key={word}
              type="button"
              onClick={() => onSearch(word)}
              className="whitespace-nowrap rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs text-background-100 backdrop-blur-sm transition-colors hover:bg-accent-500 hover:text-background-50"
            >
              {word}
            </button>
          ))}
        </div>

        <div className="mt-10 grid w-full max-w-3xl grid-cols-2 gap-3 sm:grid-cols-5">
          {categories.map((cat) => (
            <button
              key={cat.key}
              type="button"
              onClick={() => onPickCategory(cat.key)}
              className="group flex flex-col items-center gap-2 rounded-xl border border-background-50/20 bg-background-50/10 px-2 py-4 backdrop-blur-sm transition-colors hover:bg-accent-500 hover:border-accent-500"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50/15 text-background-50 transition-colors group-hover:bg-background-50 group-hover:text-accent-600">
                <i className={`${cat.icon} text-lg`} />
              </span>
              <span className="whitespace-nowrap text-xs text-background-100">{cat.name}</span>
            </button>
          ))}
        </div>

        <div className="mt-10 grid w-full max-w-3xl grid-cols-2 gap-6 border-t border-background-50/20 pt-8 text-center sm:grid-cols-4">
          <div>
            <p className="font-heading text-2xl text-accent-300 md:text-3xl">10w+</p>
            <p className="mt-1 text-xs text-background-200">累计视频内容</p>
          </div>
          <div>
            <p className="font-heading text-2xl text-accent-300 md:text-3xl">98%</p>
            <p className="mt-1 text-xs text-background-200">用户追更满意度</p>
          </div>
          <div>
            <p className="font-heading text-2xl text-accent-300 md:text-3xl">5 大</p>
            <p className="mt-1 text-xs text-background-200">内容分类</p>
          </div>
          <div>
            <p className="font-heading text-2xl text-accent-300 md:text-3xl">24h</p>
            <p className="mt-1 text-xs text-background-200">每日滚动更新</p>
          </div>
        </div>
      </div>
    </section>
  );
}